import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import {PaymentIconsStyled, PaymentIcon} from './PaymentIcons.style';
import mastercard from '../../assets/images/payment_logo--mastercard.svg';
import paypal from '../../assets/images/payment_logo--paypal.svg';
import visa from '../../assets/images/payment_logo--visa.svg';

export class PaymentIcons extends PureComponent {
  render() {
    const {supportCreditCard, supportPayPal} = this.props;
    const renderPayPal = supportPayPal &&
      <PaymentIcon>
        <img
          src={paypal}
          alt="paypal"
        />
      </PaymentIcon>;
    const renderCards = supportCreditCard &&
      <PaymentIconsStyled>
        <PaymentIcon>
          <Isvg src={visa} />
        </PaymentIcon>
        <PaymentIcon>
          <Isvg src={mastercard} />
        </PaymentIcon>
        {renderPayPal}
      </PaymentIconsStyled>;
    return (
      <PaymentIconsStyled>
        {renderCards}
      </PaymentIconsStyled>
    );
  }
}

PaymentIcons.propTypes = {
  supportCreditCard: PropTypes.bool.isRequired,
  supportPayPal: PropTypes.bool.isRequired
};

PaymentIcons.defaultProps = {
  supportCreditCard: true,
  supportPayPal: true
};

export default PaymentIcons;



// WEBPACK FOOTER //
// ./components/PaymentIcons/PaymentIcons.js